<template>
    <footer class="footer container-fluid">
        <nav class="footer-nav">
            <a href="https://www.swift.co">Swift.co</a>
            <a href="https://instagram.com/swift_flightschool"><span class="instagram_icon"></span></a>
            <!-- <router-link to="/faq">FAQ</router-link> -->
        </nav>
        <div class="footer-buildings">
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style lang="scss" scoped>

</style>